export default class DropdownMobile {
	constructor() {
		this.dropdownItems = document.querySelectorAll(".jsFliterModalAttrItem");
		this.dropdownPanels = document.querySelectorAll(".jsFliterModalPanel");
		this.dropdownTitlesPanel = document.querySelectorAll(".jsTitlePanel");
		this.modalContent = document.querySelectorAll(".jsFitersModalContent");
		this.body = document.body;
		this.events();
	}

	events() {
		const th = this;
		if (this.dropdownItems) {
			this.dropdownItems.forEach((dropdown) => {
				const dropdownKey = dropdown.dataset.key;
				dropdown.addEventListener("click", (e) => {
					e.preventDefault();
					const panelParent = dropdown.closest(".jsFitersModalContent");
					if (panelParent) {
						panelParent.classList.add("is-panel-open");
					}
					th.dropdownPanels.forEach((panel) => {
						if (panel.classList.contains(`jsPanelMobile--${dropdownKey}`)) {
							panel.classList.add("is-open");
						}
					});
				});
			});
		}

		if (this.dropdownTitlesPanel) {
			this.dropdownTitlesPanel.forEach((title) => {
				title.addEventListener("click", (e) => {
					e.preventDefault();
					const parentWrapper = title.parentElement;
					this.modalContent.forEach((content) => {
						content.classList.remove("is-panel-open");
					});
					if (parentWrapper.classList.contains("is-open")) {
						parentWrapper.classList.remove("is-open");
					}
				});
			});
		}
	}
}
